module.exports = __webpack_public_path__ + "img/bog-profile.f62b61e4.jpg";